import { render, staticRenderFns } from "./crudPHPCron.vue?vue&type=template&id=5673212a&"
import script from "./crudPHPCron.vue?vue&type=script&lang=js&"
export * from "./crudPHPCron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports